import styled from '@emotion/styled';
import { fontSizes, lineHeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const StyledText = styled.div`
    font-size: ${fontSizes.small};
    line-height: ${lineHeights.small};
`;

export const StyledTo = styled(StyledText)`
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    margin-bottom: ${gutterSizes.medium};
`;
